var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62109 12.1212H35.0004V34.6487H8.62109V12.1212ZM9.90433 18.074H33.7157V33.248H9.90433V18.074ZM13.1756 14.5724H11.8917V15.8564H13.1756V14.5724ZM14.691 14.5724H15.975V15.8564H14.691V14.5724ZM18.7787 14.5724H17.4948V15.8564H18.7787V14.5724Z",
    fill: "#1A1F36"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.6523,
    y: 19.7081,
    width: 5.13579,
    height: 2.33445,
    fill: "#7B3BE3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6523,
    y: 24.4938,
    width: 5.13579,
    height: 2.33445,
    fill: "#7B3BE3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6523,
    y: 29.2795,
    width: 5.13579,
    height: 2.33445,
    fill: "#7B3BE3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2422,
    y: 19.7081,
    width: 5.13579,
    height: 2.33445,
    fill: "#7B3BE3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2422,
    y: 24.4938,
    width: 5.13579,
    height: 2.33445,
    fill: "#7B3BE3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2422,
    y: 29.2795,
    width: 5.13579,
    height: 2.33445,
    fill: "#7B3BE3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8281,
    y: 19.7081,
    width: 5.13579,
    height: 2.33445,
    fill: "#7B3BE3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8281,
    y: 24.4938,
    width: 5.13579,
    height: 2.33445,
    fill: "#7B3BE3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8281,
    y: 29.2795,
    width: 5.13579,
    height: 2.33445,
    fill: "#7B3BE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96857 9.20316V5.35132H8.85184L5 9.20316H8.96857Z",
    fill: "#1A1F36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5589 5.35132H10.1358V10.4871H5V26.4197H7.39281V10.8956H23.5589V5.35132Z",
    fill: "#1A1F36"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.f86f67ea73b86ec763c0c1736616b3bc.svg";
export { ForwardRef as ReactComponent };